(function ($, Drupal) {
  'use strict'
  Drupal.behaviors.popup = {
    attach: function (context, settings) {
      const html = document.querySelector('html');
      const popup = document.querySelector('.js-newsletter-popup', context);
      const close = $('.js-newsletter-popup-close', context);
      const title = document.querySelector('.js-newsletter-popup .field-title-text h2');

      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
      }

      $('.js-popup-close', context).on('click', function(e) {
        e.stopPropagation();
        enableScroll();
        const id = $(this).data('popup');
        $(`.js-popup[data-popup="${id}"]`, context).removeClass('show');
      });
      $('.js-popup-open', context).on('click', function() {
        disableScroll();
        const id = $(this).data('popup');
        $(`.js-popup[data-popup="${id}"]`, context).addClass('show');
      });


      function closeNewsletter() {
        popup.classList.remove('show-popup');
        var exp_date = new Date();
        exp_date.setTime(exp_date.getTime() + (183 * 24 * 60 * 60 * 1000));
        document.cookie = 'hide_newsletter_popup_'+ html.lang + '=1; expires=' + exp_date.toGMTString() + '; path=/';
      }

      function init() {
        const newsletterPopupCookie = getCookie(`hide_newsletter_popup_${html.lang}`);
        if (newsletterPopupCookie) return;
        if (popup) {
          const {mobile, popupDelay, includeFlag, paramKeyIncl, paramValueIncl, urlParamIncl, excludeFlag, urlParamExcl, paramKeyExcl, paramValueExcl, blockId, blockRanking} = popup.dataset;
          popupParamInit(mobile, popupDelay, includeFlag, paramKeyIncl, paramValueIncl, urlParamIncl, excludeFlag, urlParamExcl, paramKeyExcl, paramValueExcl, blockId, blockRanking, popup);
        }
      }

      function showPopup(mobile, popupDelay, popup) {
        // const siteKey = document.getElementById('g-recaptcha-sitekey-popup');
        const form = popup.querySelector('.js-newsletter-form');
        const recaptchaScript = document.createElement('script');

        const body = document.querySelector('body');
        const userCategory = body.dataset.userCategory;
        const pageUrl = body.dataset.pageUrl;


        const gaData = {
          event: 'ga-event',
          eventCategory: 'pop-up',
          eventAction: 'view',
          eventLabel: 'newsletter-popup_view',
          userCategory: userCategory,
          pageUrl: pageUrl,
        };

        setTimeout(() => {
          if (mobile === '0') {
            popup.classList.add('show-popup');
            pushData(gaData);
          } else if ((window.innerWidth > 767)) {
            popup.classList.add('show-popup');
            pushData(gaData);
          }
          // recaptchaScript.type = 'text/javascript';
          // recaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
          // form.insertBefore(recaptchaScript, form.firstChild);
        }, (popupDelay ? popupDelay : 1) * 1000);
      }

      close.on('click', function(e) {
        e.stopPropagation();
        enableScroll();
        closeNewsletter();
      });

      if (popup) {
        popup.addEventListener('click', function(e) {
          if (e.target.classList.contains('newsletter-popup')) {
            closeNewsletter();
            createCookie(cookieName, '', 180);
            pushData({
              event: 'ga-event',
              eventCategory: 'pop-up',
              eventAction: 'close',
              eventLabel: `${title.innerText.split(' ').join('_')}_close`,
            });
          }
        });
      }

      function popupParamInit(mobile, popupDelay, includeFlag, paramKeyIncl, paramValueIncl, urlParamIncl, excludeFlag, urlParamExcl, paramKeyExcl, paramValueExcl, blockId, blockRanking, popup) {
        const urlValue = window.location.href;
        // Priority (1) nothing set.
        if ((includeFlag === '0') && (excludeFlag === '0')) {
          showPopup(mobile, popupDelay, popup);
          return;
        }

        // Priority (2). exclude flag check and execute key value pair (do not show, return)
        if ((excludeFlag === '1')) {
          if ((urlParamExcl != '' && urlParamExcl != null)) {
            const excludeURLMatch = urlValue.indexOf(urlParamExcl) > -1;
            if (excludeURLMatch) return
            if (!excludeURLMatch) showPopup(mobile, popupDelay, popup);
          }
          if (urlParamExcl == '') {
            if ((paramKeyExcl != '' && paramKeyExcl != null) && (paramValueExcl != '' && paramValueExcl != null)) {
              const excludePairsMatch = urlValue.split(paramKeyExcl)[1].split('?')[0].includes(paramValueExcl);
              if (excludePairsMatch) return;
              if (!excludePairsMatch) showPopup(mobile, popupDelay, popup);
            }
          }
        }

        // Priority (3) inclusion check (1) if nothing is set to exclusion (1)
        if ((excludeFlag === '0') && (includeFlag === '1')) {
          if ((urlParamIncl != '' && urlParamIncl != null) && (urlValue.indexOf(urlParamIncl) > -1)) {
            showPopup(mobile, popupDelay, popup);
            return
          };
          if ((paramKeyIncl !== '' && paramValueIncl != null) && (paramValueIncl != '' && paramValueIncl != null)) {
            if (urlParamIncl == '') {
              if (urlValue.split(paramKeyIncl)[1].split('?')[0].includes(paramValueIncl)) {
                showPopup(mobile, popupDelay, popup);
                return
              };
            }
          }
          if (urlParamIncl !== '' && urlValue.includes(urlParamIncl)) {
            showPopup(mobile, popupDelay, popup);
            return;
          }
        }
      }

      init();
    }
  }

}) (jQuery, Drupal)



